import { ButtonComponent } from "app/shared/action-btns/button.component";
import { ConnectionIconComponent } from "app/shared/cell-renderers/connection-icon/connection-icon.component";

export const DATASOURCE_CONFIG_COLUMN_DEF = [
  {headerName: 'DS Name', field: 'name', sortable: true},
  {headerName: 'DS Type', field: 'datasourceType', sortable: true},
  {headerName: 'Host', field: 'server', sortable: true},
  {headerName: 'Port', field: 'port', sortable: true},
  {headerName: 'Status', field: 'isConnected', sortable: true, cellRendererFramework: ConnectionIconComponent},
  {headerName: 'Client ID', field: 'clientId', sortable: true},
  {headerName: 'Action', field: 'action', lockVisible: true, sortable: false, cellRendererFramework:  ButtonComponent,
    meta: {
      iconType: "tree",
    }
  },
];

export const DATASOURCE_TYPE = {
  intellijaBroker: 'Intellija Broker',
  mqtt: 'Sparkplug MQTT',
  opcUa: 'OPC-UA',
}

export const CExpandStatus = {
  Expand: 'Expand',
  Collapse: 'Collapse'
}
